import React from 'react';
import { Form, Modal, Select, DatePicker, InputNumber, TimePicker, Row, Col, Input } from 'antd';

import { SITE_NAMES } from '~/constants/sites';

import moment from 'moment';

class AddSessionForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = { online: false, hasDeadline: false, deadlineDefaultValue: null };
        this.handleSiteChange = this.handleSiteChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
    }

    componentDidUpdate(prevProps) {
        // If the crouse being edited changed, rerun typeHandler to see if we need to show/hide the day dropdown
        if (prevProps.id !== this.props.id) {
            this.handleSiteChange(this.props.form.getFieldValue("site"));
        }
    }

    handleSiteChange(e) {

        this.setState({
            online: e === "ONLINE" || e === "VIRTUAL",
            hasDeadline: e === "ONLINE"
        });

    };

    handleDateChange(date) {

        const parsedDate = moment(date);
        const dateAtMidnight = parsedDate.endOf('day');
        this.setState({ deadlineDefaultValue: dateAtMidnight })

    };

    render() {
        const { visible, onCancel, onOk, form } = this.props;
        const { getFieldDecorator } = form;
        // initialize an empty array of course
        let courseOptions = [];
        this.props.courses.forEach((object, key) => {
            courseOptions.push(<Select.Option key={key} value={object.courseID}>{object.title}</Select.Option>)
        });

        return (
            <Modal visible={visible}
                title='Add a session'
                okText='Add session'
                onCancel={onCancel}
                onOk={onOk}
            >
                <Form layout='vertical'>
                    <Form.Item label='Course'>
                        {getFieldDecorator('course', {
                            initialValue: this.props.selectedCourse,
                            rules: [{ required: true, message: 'Please select a course' }]
                        })(
                            <Select>
                                {courseOptions}
                            </Select>
                        )}
                    </Form.Item>
                    <Form.Item label='Site'>
                        {getFieldDecorator('site', { rules: [{ required: true, message: 'Please select a Site' }] })(
                            <Select onChange={this.handleSiteChange}>
                                {Object.entries(SITE_NAMES).map(([SITE_VALUE, SITE_NAME]) => {
                                    return (<Select.Option key={SITE_VALUE}
                                        value={SITE_VALUE}>{SITE_NAME}</Select.Option>)
                                })}
                            </Select>
                        )}
                    </Form.Item>
                    <Row gutter={16}>
                        <Col span={8}>
                            <Form.Item label='Date'>
                                {getFieldDecorator('date', {
                                    rules: [{
                                        type: 'object',
                                        required: true,
                                        message: 'Please enter a date.'
                                    }]
                                })(
                                    <DatePicker format='YYYY-MM-DD' onChange={this.handleDateChange} />
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label='Start Time'>
                                {getFieldDecorator('startTime', {
                                    rules: [{
                                        type: 'object',
                                        required: true,
                                        message: 'Please enter a start time.'
                                    }]
                                })(
                                    <TimePicker use12Hours format="h:mm a" />
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label='End Time'>
                                {getFieldDecorator('endTime', {
                                    rules: [{
                                        type: 'object',
                                        required: true,
                                        message: 'Please enter an end time.'
                                    }]
                                })(
                                    <TimePicker use12Hours format="h:mm a" />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item label="Deadline" style={{ display: !this.state.hasDeadline ? "none" : null }}>
                        {getFieldDecorator('deadline', {
                            rules: [{ required: true }],
                            initialValue: this.state.deadlineDefaultValue,
                        })(
                            <DatePicker showTime={{ use12Hours: true }} placeholder="Deadline" onChange={undefined}
                                onOk={undefined} />
                        )}
                    </Form.Item>
                    <Form.Item label={this.state.online ? 'URL' : 'Location'}>
                        {getFieldDecorator('location', {
                            rules: [{
                                required: !this.state.online,
                                message: this.state.online ? 'Please enter a URL' : 'Please enter a Location'
                            }, {
                                type: this.state.online ? 'url' : 'string',
                                message: this.state.online ? 'Please enter a valid URL (inlcuding "https://")' : 'Please enter a location'
                            }]
                        })(
                            <Input placeholder={this.state.online ? 'URL' : 'Location'} />
                        )}
                    </Form.Item>
                    {/* <FormItem name='location' item='location' placeholder='Location' label='Location' required={true} form={this.props.form} /> */}
                    <Form.Item name='capacity' item='capacity' placeholder='Capacity' label='Capacity'>
                        {getFieldDecorator('capacity', {
                            rules: [{ type: 'number', }],
                        })(<InputNumber />)}
                    </Form.Item>
                    {/* <FormItem name='capacity' item='capacity' placeholder='Capacity' label='Capacity' required={true} form={this.props.form} /> */}
                </Form>
            </Modal>
        );
    }
}

export default Form.create()(AddSessionForm);
